module.exports = __webpack_public_path__ + "static/media/WorkSpaces_Web_logo.99a08540.png";